/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../../component/Inc/Tab';
import Paging from '../../../component/Inc/Paging';
import PopRequestPoint from '../../mypage/_PopRequestPoint';//포인트, 직급 가점 요청
import PopPolicyPoint from '../../mypage/_PopPolicyPoint';//포인트 정책
import PopPolicyPosition from '../../mypage/_PopPolicyPosition';//직급가점 정책
function AssignManage() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const [modalRequestPointyOpen, setModalRequestPointyOpen] = useState(false);
  const [modalPolicyOpen, setModalPolicyOpen] = useState(false);
  const [modalPositionOpen, setModalPositionOpen] = useState(false);
  const tab = [
    {title: '포인트 승인요청', cnt: '45', value: 0},
    {title: '포인트 승인 완료', cnt: '45', value: 1},
    {title: '직급가점 승인요청', cnt: '45', value: 2},
    {title: '직급가점 승인완료', cnt: '45', value: 3},
    {title: '내 승인요청', cnt: '456', type: ' red', value: 4}
  ];
  //const [modalMentorReport, setModalMentorReport] = useState(false);
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_8">시수 관리</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalPolicyOpen(true)} className="com_btn orange s btn_settings">포인트 정책</button>
            <button onClick={() => setModalPositionOpen(true)} className="com_btn orange s btn_settings">직급가점 정책</button>
            <button onClick={() => setModalRequestPointyOpen(true)} className="com_btn orange s btn_plus">포인트 & 직급가점 요청</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk1" className="com_chk" />
                <label htmlFor="chk1">직급 평가 대상자</label>
              </span>
							<section className="com_board_search end divider">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="5.5%" />
                <col width="5.5%" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="auto" />
                <col width="7%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>지급자</th>
                  <th>직급</th>
                  <th>
                    시수
                    <span className="sub">(지도관리/원고/장기/특별)</span>
                  </th>
                  <th>요청항목</th>
                  <th>요청내용</th>
                  <th>
                    요청 <br /> 포인트
                  </th>
                  <th>
                    요청 <br /> 직급 가점
                  </th>
                  <th>
                    보유 <br /> 포인트&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    보유 <br /> 직급 가점&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    필요
                    <br /> 포인트&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    필요
                    <br /> 직급 가점&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2023, 05, 23</td>
                  <td>
                    <Link to="/Teacher/MentorManage/Detail" className="btn_link">
                      김요청305
                    </Link>
                  </td>
                  <td>
                    <button className="btn_link">홍길동</button>
                  </td>
                  <td>일반1호봉 (평가 대상)</td>
                  <td>
                    45000
                    <br />
                    (30000/5000/5000/100)
                  </td>
                  <td>교재제작검토</td>
                  <td>8월초타오류 검수</td>
                  <td className="com_red_txt bg_col">-45</td>
                  <td className="com_blue_txt bg_col">12</td>
                  <td>64</td>
                  <td>645</td>
                  <td>64</td>
                  <td>-</td>
                  <td className="td_red line">
                    승인불가
                    <br /> 2025, 08, 30
                  </td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2023, 05, 23</td>
                      <td>
                        <Link to="/Teacher/MentorManage/Detail" className="btn_link">
                          김요청305
                        </Link>
                      </td>
                      <td>
                        <button className="btn_link">홍길동</button>
                      </td>
                      <td>일반1호봉 (평가 대상)</td>
                      <td>
                        45000
                        <br />
                        (30000/5000/5000/100)
                      </td>
                      <td>교재제작검토</td>
                      <td>8월초타오류 검수</td>
                      <td className="com_blue_txt bg_col">+45</td>
                      <td className="com_blue_txt bg_col">12</td>
                      <td>64</td>
                      <td>645</td>
                      <td>64</td>
                      <td>-</td>
                      <td className="td_point">
                        승인
                        <br /> 2025, 08, 30
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalRequestPointyOpen} close={() => setModalRequestPointyOpen(false)} />
      <PopPolicyPosition open={modalPositionOpen} close={() => setModalPositionOpen(false)} />
      <PopPolicyPoint open={modalPolicyOpen} close={() => setModalPolicyOpen(false)} />
    </main>
  );
}

export default AssignManage;
